import React from 'react';
import { Button } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setDialogMode, openDialog, selectDeliveryLocation } from '../../../redux/slices/deliveryLocation';

const AddDeliveryLocation = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * モーダルオープン
   */
  const handleAddDeliveryLocation = (): void => {
    dispatch(selectDeliveryLocation());
    dispatch(setDialogMode('CREATE'));
    dispatch(openDialog());
  };

  // VIEW
  // ================================================================================

  return (
    <Button className="mr-2" theme="white" onClick={handleAddDeliveryLocation}>
      <i className="material-icons">add</i>
      {t('deliveryLocation.add')}
    </Button>
  );
};

export default AddDeliveryLocation;
